/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Style_Guides_Retrieved_MessageInputs */

const en_iframe_remote_style_guides_retrieved_message = /** @type {(inputs: Iframe_Remote_Style_Guides_Retrieved_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style guides retrieved successfully`)
};

const fr_iframe_remote_style_guides_retrieved_message = /** @type {(inputs: Iframe_Remote_Style_Guides_Retrieved_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guides de style recuperes avec succes`)
};

const de_iframe_remote_style_guides_retrieved_message = /** @type {(inputs: Iframe_Remote_Style_Guides_Retrieved_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Styleguides erfolgreich abgerufen`)
};

const it_iframe_remote_style_guides_retrieved_message = /** @type {(inputs: Iframe_Remote_Style_Guides_Retrieved_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guide di stile recuperate con successo`)
};

const ru_iframe_remote_style_guides_retrieved_message = /** @type {(inputs: Iframe_Remote_Style_Guides_Retrieved_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Руководства по стилю успешно получены`)
};

const es_iframe_remote_style_guides_retrieved_message = /** @type {(inputs: Iframe_Remote_Style_Guides_Retrieved_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guías de estilo recuperadas con éxito`)
};

const zh_cn2_iframe_remote_style_guides_retrieved_message = /** @type {(inputs: Iframe_Remote_Style_Guides_Retrieved_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已成功检索到样式指南`)
};

const ja_iframe_remote_style_guides_retrieved_message = /** @type {(inputs: Iframe_Remote_Style_Guides_Retrieved_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタイルガイドが正常に取得されました`)
};

const hi_iframe_remote_style_guides_retrieved_message = /** @type {(inputs: Iframe_Remote_Style_Guides_Retrieved_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शैली मार्गदर्शिकाएँ सफलतापूर्वक प्राप्त कर ली गईं`)
};

const pt_pt2_iframe_remote_style_guides_retrieved_message = /** @type {(inputs: Iframe_Remote_Style_Guides_Retrieved_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guias de estilo recuperados com sucesso`)
};

/**
* | output |
* | --- |
* | "Style guides retrieved successfully" |
*
* @param {Iframe_Remote_Style_Guides_Retrieved_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_style_guides_retrieved_message = /** @type {((inputs?: Iframe_Remote_Style_Guides_Retrieved_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Style_Guides_Retrieved_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_style_guides_retrieved_message(inputs)
	if (locale === "de") return de_iframe_remote_style_guides_retrieved_message(inputs)
	if (locale === "it") return it_iframe_remote_style_guides_retrieved_message(inputs)
	if (locale === "ru") return ru_iframe_remote_style_guides_retrieved_message(inputs)
	if (locale === "es") return es_iframe_remote_style_guides_retrieved_message(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_style_guides_retrieved_message(inputs)
	if (locale === "ja") return ja_iframe_remote_style_guides_retrieved_message(inputs)
	if (locale === "hi") return hi_iframe_remote_style_guides_retrieved_message(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_style_guides_retrieved_message(inputs)
	return en_iframe_remote_style_guides_retrieved_message(inputs)
});